import { FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';


export default function getCallbackForAction(props, canPlayFullOrPreview, fullAccessAction) {
  if (canPlayFullOrPreview) {
    return props.onPlayRequest;
  } else if (fullAccessAction === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
    return props.onPlayMemberOnlyRequest;
  }

  return props.onPlayWithoutPreviewRequest;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/channel-overlay/play/callback.js